module.exports = __webpack_public_path__ + "img/btn_mobysign_signin_normal.ee304f30.svg";